import React from "react";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "./dialog.jsx";

export default function TryRazeenPlusModal() {
  const [isOpen, setIsOpen] = React.useState(true);

  return (
    <Dialog modal open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-[45rem]" withCloseButton={false}>
        <div className="w-full">
          <img src="/new-razeen.png" alt="" />
        </div>

        <div className="flex flex-col gap-2 items-center justify-center text-center">
          <div className="text-black text-[2rem]">
            <span className="font-bold">Razeen+</span> a new look, a smarter
            experience.✨
          </div>

          <div className="text-[#72707A] mt-2">
            Razeen+ is an upgraded version of Razeen, offering smarter insights,
            faster performance, and a more personalized experience.
          </div>

          <a
            href="https://app.razeen.io"
            className="mt-4 w-full bg-[#5E45FF] text-[#fff] p-3 rounded-full font-bold"
          >
            Try it Now!
          </a>

          <button
            onClick={() => {
              setIsOpen(false);
            }}
            className="mt-4 text-[#FDB236] font-bold"
          >
            Remind me later
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
